// @SEE http://t.xg.boleme.net/md/doc.html#/default/product-api-impl/getProductBoxTypeEnumsUsingGET

// 简单跳转
export const BOX_TYPE_OPEN_IN_NEW_TAB_WITHOUT_TOKEN = 0;
// iframe 中展示的部分
export const BOX_TYPE_EMBEDDED = 1;
// 在新的 tab 中打开
// alias BOX_TYPE_ALERT
export const BOX_TYPE_OPEN_IN_NEW_TAB_WITH_TOKEN = 2;
